import { useMutation, useQueryClient } from '@tanstack/react-query';
import { bulkExcludeEmployeeFromCourses } from '../../../services/MoodleService';
import { moodleQueryKeys } from '../all-query-keys';

export const useBulkExcludeEmployeeFromCourses = (onSuccess) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: (payload) => bulkExcludeEmployeeFromCourses(payload),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: [moodleQueryKeys.courseExclusions],
      });
      onSuccess?.(...args);
    },
  });

  return { mutate, isPending };
};
